import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../ExperimentKeys';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { setFlow } from '../../store/flow/action-creators';
import I18n from 'I18n';
import { Step } from 'signup-constants/Step';
import { isProd } from '../../constants/apiEnvironments';
import { AdditionalSeatsSkuId } from './ACQ151SkuIds';
var ACQ151StepIndicatorSteps;
(function (ACQ151StepIndicatorSteps) {
  ACQ151StepIndicatorSteps["ChooseSeats"] = "choose-seats";
  ACQ151StepIndicatorSteps["Signup"] = "signup";
  ACQ151StepIndicatorSteps["Checkout"] = "checkout";
})(ACQ151StepIndicatorSteps || (ACQ151StepIndicatorSteps = {}));
const ACQ151MappedLoadingKeys = new Map([[LoadingKey.SignupRequest, LoadingKey.ACQ151SignupRequest], [LoadingKey.LoginAfterSignup, LoadingKey.ACQ151PortalCreated]]);
export const getACQ151EndpointLoadingKey = (state, loadingKey) => {
  const parameter = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0151, [ExperimentParameterGroup.Variant_A]);
  if (parameter && loadingKey && ACQ151MappedLoadingKeys.has(loadingKey)) return ACQ151MappedLoadingKeys.get(loadingKey);
  return loadingKey;
};
export const setFlowForACQ151 = ({
  isPreVerificationExistingUserSession = false
}) => dispatch => {
  const {
    postExistingAccountSelection,
    postAccountCreation
  } = getFlowSteps();
  const variantPreVerificationSteps = [Step.ChooseSeats, Step.LandingPage, Step.CodeVerification];
  const variantPostVerificationSteps = [Step.Password, Step.Name, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection];
  const nextSteps = [...(isPreVerificationExistingUserSession ? [Step.ExistingUser] : []), ...(isPreVerification() ? variantPreVerificationSteps : []), ...variantPostVerificationSteps, ...postAccountCreation];
  const flowSteps = {
    nextSteps,
    variantPreVerificationSteps,
    variantPostVerificationSteps,
    postAccountCreation,
    postExistingAccountSelection
  };
  dispatch(setFlow(flowSteps.nextSteps, flowSteps.variantPreVerificationSteps, flowSteps.variantPostVerificationSteps, flowSteps.postAccountCreation, flowSteps.postExistingAccountSelection));
  return nextSteps;
};
export const getAdditionSeatsSkuId = () => {
  return isProd ? AdditionalSeatsSkuId.PROD : AdditionalSeatsSkuId.QA;
};
export const getStepNames = () => {
  return Object.values(ACQ151StepIndicatorSteps).map(stepName => {
    return I18n.text(`views.${Step.ChooseSeats}.options.${stepName}`);
  });
};
export const splitProductAndAdditional = productsInfo => {
  return productsInfo.reduce((splitItems, product) => {
    if (product.skuId === getAdditionSeatsSkuId()) {
      splitItems.additional.push(product);
    } else {
      splitItems.products.push(product);
    }
    return splitItems;
  }, {
    products: [],
    additional: []
  });
};